import React from 'react';
import { ProductInfo } from '../../ProductInfo';

export const BottomProductInfoView: React.FC = () => {
  return <ProductInfo hideOnEmpty={true} />;
};
